import { render, staticRenderFns } from "./TagCategory.vue?vue&type=template&id=1d6c9f76"
import script from "./TagCategory.vue?vue&type=script&lang=js"
export * from "./TagCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports